import React from 'react';

export default function TopBarContainer({ ...props }) {

    return (
        <div className="h-[48px] px-3 text-sm flex content-between items-center border-b border-slate-150">
            {props.children}
        </div>
    );
}